import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {GenericDocApprovalHeaderContainerModel} from '../../../../../../models/aggregates/erp/generic-approval';
import { ApiResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class GenericDocApprovalHeaderService extends BaseApiTemplateService<GenericDocApprovalHeaderContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/backoffice-ep';
    this.httpClient = http;
  }

   submit(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
         this.apiUrl = visa.api_domain_url + this.endpoint_path;
         customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/processors/submission/backoffice-ep';
      }
      return this.httpClient.put<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

   reSubmit(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
        customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/processors/resubmission/backoffice-ep';
      }
      return this.httpClient.put<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

   withdraw(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
        customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/processors/withdrawals/backoffice-ep';
      }
      return this.httpClient.put<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

}
